import _PrintService from './PrintService';

// eslint-disable-next-line import/prefer-default-export
export const PrintService = _PrintService;
